import { render, staticRenderFns } from "./OrderTakDetail.vue?vue&type=template&id=f75d3938&"
import script from "./OrderTakDetail.vue?vue&type=script&lang=js&"
export * from "./OrderTakDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports